<template>
  <v-dialog
    v-model="dialog"
    :width="dialogWidth"
    transition="fade-transition"
    :scrollable="true"
  >
    <v-card>
      <v-card-title class="headline">{{ $t("onlineIdsDialog.title") }}</v-card-title>
      <v-card-text>        
        <online-ids />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="secondary" text @click="close()">
          <v-icon left>mdi-close</v-icon>{{ $t("common.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OnlineIds from "@/widgets/OnlineIds";

export default {
  name: "OnlineIdsDialog",
  mixins: [],
  components: { OnlineIds },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.closeAction();
      }
    },
  },
  computed: {
    dialogWidth: function () {
      if (this.$vuetify.breakpoint.smAndUp) {
        return "700";
      }
      return "90%";
    },
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    close() {
      this.$emit("input", null);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
</style>